class JsonService {

    static isJson(jsonString:string){
        try{
            JSON.parse(jsonString);

            return true;
        }catch(err){
            return false;
        }
    }

    static parseJson(json:string){
        return JSON.parse(json);
    }

    static parseObject(json: string){
        var isValidJson = this.isJson(json);
        var object = isValidJson ? this.parseJson(json) : {}

        return object;
    }
}

export default JsonService;